import React from 'react';
import ReactList from 'react-list'; // eslint-disable-line import/no-extraneous-dependencies
import DownloadFromLink from '../../../display/components/DownloadFromLink';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Clear from '@material-ui/icons/Clear';
import { IconButton, FormControl, InputLabel } from '@material-ui/core';
import { enqueueSnackbar as enqueueSnackbarAction } from 'notistack/actions';
import { asyncEventsInProgressContext } from '../../../../bpm/components/TaskDetail/asyncEventCountContext';
import { getOnDrop } from './getOnDrop';

const styles = theme => ({
    button: {
        width: 24,
        height: 24,
        padding: 0,
    },
    error: {
        color: theme.palette.error.main,
        fontSize: 'small',
    },
});
const dispatches = {
    enqueueSnackbar: enqueueSnackbarAction,
};
type Dispatches = typeof dispatches;

interface MultipleFileInputProps extends Dispatches {
    disabled: boolean;
    showNotification: any; //tslint:disable-line
    input: {
        onBlur: (value: any[]) => void;
        value: any;
    };
    classes: { button: string; error: string }; //tslint:disable-line
    label: string;
    taskId: string;
    source: string;
    meta: {
        error: string;
        touched: boolean;
    };
}

class MultipleFileInput extends React.Component<MultipleFileInputProps, { inputKey: number }> {
    state = {
        inputKey: 1,
    };
    getInputValue = (inputValue = this.props.input.value) => {
        if (inputValue) {
            if (Array.isArray(inputValue)) {
                return inputValue;
            }
            // not sure why this case was added before refactoring... but keeping it in case it was a good reason.
            return [inputValue];
        }
        return [];
    };
    getOnDrop = (
        eventCbs: {
            beforeRequest?: () => void;
            afterRequest?: () => void;
        },
        taskId,
    ) => {
        // tslint:disable-line
        const { enqueueSnackbar } = this.props;
        return getOnDrop(
            {
                ...eventCbs,
                onResponse: statusCode => {
                    const didFail = statusCode < 200 || statusCode >= 300;
                    enqueueSnackbar({
                        message: didFail ? 'Upload failed' : 'Upload succeeded',
                        options: {
                            variant: didFail ? 'error' : 'success',
                        },
                    });
                },
                onNetworkError: () => {
                    enqueueSnackbar({
                        message: 'Network error',
                        options: { variant: 'error' },
                    });
                },
                onSuccessWithData: dataParsed => {
                    this.props.input.onBlur([...this.getInputValue(), dataParsed]);
                },
            },
            taskId,
        ); // tslint:disable-line
    };

    handleUrlClear = id => {
        this.setState(({ inputKey }) => ({ inputKey: inputKey + 1 }));
        const remaining = this.getInputValue().filter(file => file.id !== id);
        this.props.input.onBlur(remaining);
    };
    render() {
        const { meta, classes } = this.props;
        const data = this.getInputValue();
        return (
            <FormControl margin="none" style={{ width: '100%' }}>
                <InputLabel shrink={true} style={{ marginBottom: '10px' }}>
                    {this.props.label}
                </InputLabel>
                <div style={{ marginTop: '16px' }}>
                    {!this.props.disabled ? (
                        <input
                            key={this.state.inputKey}
                            type="button"
                            value="Choose File"
                            onClick={() =>
                                document.getElementById(this.props.source) &&
                                document.getElementById(this.props.source)!.click()
                            }
                        />
                    ) : null}
                    <asyncEventsInProgressContext.Consumer>
                        {({ increment, decrement }) => {
                            return (
                                <input
                                    key={this.state.inputKey}
                                    type="file"
                                    style={{ display: 'none' }}
                                    id={this.props.source}
                                    onChange={e =>
                                        e.target.files &&
                                        this.getOnDrop(
                                            {
                                                beforeRequest: increment,
                                                afterRequest: decrement,
                                            },
                                            this.props.taskId,
                                        )(e.target.files as any)
                                    } //tslint:disable-line
                                />
                            );
                        }}
                    </asyncEventsInProgressContext.Consumer>
                    {data.length === 0 ? (
                        <span style={{ fontSize: '13px' }}>&nbsp; No files chosen</span>
                    ) : (
                        <div>
                            <ReactList
                                itemRenderer={(index, key) => {
                                    const attachment = data[index];
                                    return (
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <DownloadFromLink
                                                url={`api/bpm/process-docs/${attachment.id}/raw`}
                                                fileName={attachment.fileFileName || '<no file name>'}
                                                contentType={attachment.mimeType}
                                            />
                                            {!this.props.disabled ? (
                                                <IconButton
                                                    aria-label={
                                                        'remove file' +
                                                        (attachment.fileFileName ? ` ${attachment.fileFileName}` : '')
                                                    }
                                                    className={this.props.classes.button}
                                                    onClick={() => this.handleUrlClear(attachment.id)}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            ) : null}
                                        </div>
                                    );
                                }}
                                length={data.length}
                                type="uniform"
                            />
                        </div>
                    )}
                </div>
                {meta.touched && meta.error && <span className={classes.error}>{meta.error}</span>}
            </FormControl>
        );
    }
}

const enhance = compose(
    connect(
        null,
        dispatches,
    ),
    withStyles(styles),
);

export default enhance(MultipleFileInput);
